import React from 'react';
import { motion } from 'framer-motion';
export function IdentificationSection() {
  return <section className="bg-white py-16 px-4" data-id="element-116">
      <div className="max-w-3xl mx-auto" data-id="element-117">
        <motion.h2 className="text-3xl md:text-5xl font-black text-brand-darkGreen mb-10 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-118">
          <span className="mr-2" data-id="element-119">💬</span> Este e-book es para vos si:
        </motion.h2>

        <div className="space-y-4 bg-brand-cream p-8 md:p-10 rounded-3xl border border-brand-beige shadow-lg" data-id="element-120">
          {['Querés resolver las viandas sin complicarte', 'Tenés poco tiempo', 'Buscás opciones caseras y prácticas', 'Querés sumar frutas y verduras', 'Estás cansada de pensar todos los días qué hacer'].map((item, index) => <motion.div key={index} className="flex items-center gap-4 bg-white p-4 rounded-xl shadow-sm" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-121">
              <div className="bg-brand-green/20 p-2 rounded-full" data-id="element-122">
                <span className="text-brand-green text-xl font-bold" data-id="element-123">✔</span>
              </div>
              <span className="text-lg md:text-xl font-bold text-gray-800" data-id="element-124">
                {item}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}